import React, { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { getLoginInfoMessage, setLoginInfoMessage } from '../../utils/auth';

export default function LoginInfoSection({ loggedInUser }) {
  const [loginInfo, setLoginInfo] = useState('');
  useEffect(() => { getLoginInfoMessage().then(setLoginInfo).catch(() => setLoginInfo('')); }, []);

  const save = async () => {
    try {
      await setLoginInfoMessage(loggedInUser, loginInfo);
      toast.success('Login info updated.');
    } catch (err) { toast.error(err.message || 'Failed to update login info.'); }
  };
  return (
    <div className="max-w-2xl">
      <p className="text-sm text-gray-500 dark:text-gray-400 mb-4">This message is shown on the login screen.</p>
      <textarea value={loginInfo} onChange={(e) => setLoginInfo(e.target.value)} rows={6}
        placeholder="Add change notes or update information for users." className="border p-3 rounded w-full text-black" />
      <button type="button" onClick={save} className="mt-4 bg-indigo-600 text-white px-4 py-2 rounded hover:bg-indigo-700">Save Login Info</button>
    </div>
  );
}
